import { builder, Builder } from "@builder.io/react";
import dynamic from "next/dynamic";

const availableMainStates = ["CA", "AZ", "FL", "TX"];

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);
// Disable Builder tracking pixel to avoid hydration mismatches.
builder.canTrack = false;

Builder.registerComponent(
  dynamic(() => import("./components/VideoModal/VideoModal")),
  {
    name: "VideoModal",
    inputs: [
      {
        name: "imagen",
        type: "file",
      },
      {
        name: "alt",
        type: "string",
      },
      {
        name: "videoId",
        type: "string",
      }
    ],
    image: 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F6bef27ee40d24f3b88239fd7e616f82a'
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/BookingApp/BookingAppRouteGate")),
  {
    name: "BookingApp",
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/CallToActionForm")),
  {
    name: "CallToActionForm",
    inputs: [
      {
        name: "pageCategory",
        type: "string",
        defaultValue: null,
      },
      {
        name: "textColor",
        type: "string",
        defaultValue: null,
      },
    ]
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/LocationsCarousel"), { ssr: false }),
  {
    name: "LocationsCarousel",
    inputs: [
      {
        name: "slides",
        type: 'list',
        defaultValue: [{ reviewText: "hello" }],
        subFields: [
          {
            name: "slideText",
            type: "string",
            defaultValue: '"California"',
          },
          {
            name: "image",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            required: true,
            defaultValue:
              "https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
          },
        ],
      }
    ]
  },
);

Builder.registerComponent(
  dynamic(() => import("./components/CookieBanner/CookieBanner")),
  {
    name: "CookieBanner",
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/IncludedServicesCLP/IncludedServicesCLP")),
  {
    name: "IncludedServices",
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/ExtrasServicesCLP/ExtrasServicesCLP")),
  {
    name: "ExtrasServices",
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/TownsWeServe/TownsWeServe"), { ssr: false }),
  {
    name: "TownsWeServe",
    inputs: [
      {
        name: "showAll",
        type: "boolean",
        defaultValue: true,
        helperText: "Marcar para mostrar todas las locaciones disponibles. Desmarcar para seleccionar específicas.",
      },
      {
        name: "selectedStateAbbr",
        type: "text",
        helperText: "Selecciona las locaciones específicas a mostrar (solo si 'Mostrar Todas' está desmarcado).",
        showIf: (options) => options.get('showAll') === false,
        enum: availableMainStates,
        defaultValue: null,
        required: true,
      },
    ],
  }
);

Builder.registerComponent(
  dynamic(() => import("./components/LocationsWithTowns/LocationsWithTowns"), {
    ssr: false,
  }),
  {
    name: "LocationsWithTowns",
    inputs: [
      {
        name: "slides",
        type: 'list',
        defaultValue: [{ reviewText: "hello" }],
        subFields: [
          {
            name: "slideText",
            type: "string",
            defaultValue: '"California"',
          },
          {
            name: "image",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
            required: true,
            defaultValue:
              "https://cdn.builder.io/api/v1/image/assets%2Fpwgjf0RoYWbdnJSbpBAjXNRMe9F2%2Ffb27a7c790324294af8be1c35fe30f4d",
          },
        ],
      }
    ]
  },
  
);
